<template>
    <div id="room-header"
         class="tw-absolute tw-z-10 tw-w-full tw-flex tw-justify-end tw-h-22 tw-p-7 tw-pb-10 tw-text-white background">
        <div v-if="name && show_name" class="tw-flex tw-items-center tw-mr-7 tw-opacity-75"
             :class="{'tw-opacity-100': speaking && !microphone_is_muted}">
            <i class="fas fa-sm fa-volume tw-mr-2 participants-icon"/>
            {{ name }}
        </div>

        <div :key="number_of_participants" class="tw-flex tw-items-center tw-mr-7">
            <i class="fas fa-sm fa-users tw-mr-2 participants-icon"/>
            {{ number_of_participants }} {{ number_of_participants === 1 ? $t('live.participants').slice(0, -1) :  $t('live.participants') }}
        </div>

        <div class="tw-flex tw-items-center tw-mr-7">
            {{ status_is_live ? $t('live.live') : $t('live.offline') }}
            <i :class="[{ 'live-dot': status_is_live }, 'fas fa-xs fa-circle circle-icon']"/>
        </div>

        <span class="tw-rounded tw-bg-orange-500 tw-text-white tw-font-semibold tw-px-2 tw-py-1">
            BETA
        </span>
    </div>
</template>

<script>
export default {
    name: "RoomHeader.vue",
    props: {
        number_of_participants: {
            required: true,
            type: Number,
            default: 0,
        },
        status_is_live: {
            required: true,
            type: Boolean,
            default: false,
        },
        name: {
            required: true,
        },
        speaking: {
            default: false,
        },
        show_name: {
            default: false,
        }
    },
}
</script>

<style scoped>
.background {
    background: linear-gradient(180deg, rgba(0, 0, 0, 0.48) 0%, rgba(0, 0, 0, 0) 100%);
}

.participants-icon {
    transform: translateY(1px);
}

.circle-icon {
    margin-left: 4px;
    font-size: 0.571em;
    transform: translateY(2.2px);
}

.live-dot {
    @apply tw-text-red-500;
    animation: live 2500ms 3 ease-in-out;
}

@keyframes live {
    0% {
        @apply tw-text-red-500;
    }
    15% {
        @apply tw-text-red-300;
    }
    30% {
        @apply tw-text-red-500;
    }
    100% {
        @apply tw-text-red-500;
    }
}
</style>
